import React, { useState } from 'react';

import { useMutation } from '@apollo/client';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, CircularProgress, Grid, TextField, Alert, Box } from '@mui/material';
import { Formik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';

import usersSchema from '../../../../../services/users/gqlSchema';
import { passwordSchema } from '../../validators/account';

const PasswordForm = ({ isPasswordUpdated, setIsPasswordUpdated }) => {
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const [displaySuccess, setDisplaySuccess] = useState(false);
  const [currentUserChangePassword] = useMutation(usersSchema.Mutation.currentUserChangePassword);
  const initialValues = {
    password: '',
    passwordConfirmation: '',
  };

  const onSubmit = async values => {
    setSubmitInProgress(true);
    setDisplaySuccess(false);
    try {
      const { data } = await currentUserChangePassword({ variables: { password: values.password } });
      if (data) {
        setDisplaySuccess(true);
        setIsPasswordUpdated(true);
      }
    } catch (error) {
      toast.error(error.message);
    }

    setSubmitInProgress(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={passwordSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={onSubmit}
      >
        {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <Grid container spacing={2}>
            {!isPasswordUpdated && (
              <Grid item xs={12}>
                <Alert severity='info'>Veuillez changer votre mot de passe</Alert>
              </Grid>
            )}
            <Grid item xs={12}>
              <Alert severity='warning'>
                Votre mot de passe doit contenir au minimum 8 caractères, des lettres ou des caractères spéciaux
                (!@.-_#*$%.) et des chiffres
              </Alert>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={'Mot de passe'}
                id={'password'}
                variant={'outlined'}
                fullWidth
                type={'password'}
                size={'small'}
                onChange={e => {
                  setFieldValue('password', e.target.value);
                }}
                onBlur={handleBlur}
                value={values.password}
                error={!!errors.password}
                helperText={errors.password}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label={'Confirmer votre mot de passe'}
                id={'passwordConfirmation'}
                variant={'outlined'}
                fullWidth
                type={'password'}
                size={'small'}
                onChange={e => {
                  setFieldValue('passwordConfirmation', e.target.value);
                }}
                onBlur={handleBlur}
                value={values.passwordConfirmation}
                error={!!errors.passwordConfirmation}
                helperText={errors.passwordConfirmation}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  color='primary'
                  variant='contained'
                  onClick={handleSubmit}
                  disabled={submitInProgress}
                  startIcon={
                    submitInProgress ? <CircularProgress size={'1rem'} /> : <FontAwesomeIcon icon={faArrowRight} />
                  }
                >
                  <Box component='span' sx={{ marginLeft: '5px' }}>
                    Sauvegarder
                  </Box>
                </Button>
              </Box>
            </Grid>

            {displaySuccess && (
              <Grid item xs={12}>
                <Alert severity='success'>Votre mot de passe est mis à jour.</Alert>
              </Grid>
            )}
          </Grid>
        )}
      </Formik>

      <ToastContainer />
    </>
  );
};

export default PasswordForm;
